import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class AlertGrid extends BaseComponent {
	
	static get properties() {
		return {
			user: {type: Boolean}
		};
	}
	
	constructor() {
		super();
		
		this.user = false;
		
		var alertGrid = this;
		setTimeout(function(){
			alertGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var alertGrid = this;
				
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{	
					tag: 'vaadin-combo-box',
					itemid: 'status',						
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					postinit: function(combo) {							
						combo.items = [
							{
								code: 'A',
								desc: 'Active'
							}, {
								code: 'I',
								desc: 'Inactive'
							}
						];
						combo.value = 'A';
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_ALERTS_MANAGEMENT:WRITE', 'ALERT_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					],
					listeners: {
						click: function() {							
							actionAddEdit();
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					disabled: true,
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_ALERTS_MANAGEMENT:WRITE', 'ALERT_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')
					],
					listeners: {
						click: function() {							
							actionAddEdit(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'updateStatus',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_ALERTS_MANAGEMENT:UPDATE_STATUS', 'ALERT_MANAGEMENT:UPDATE_STATUS'],
					children:[
						ElementUtil.makeIcon('vaadin:check', ' Toggle Status')
					],
					listeners: {
						click: function() {							
							actionUpdateStatus(grid.selectedItems[0]);
						}
					}
				},								
				{
					tag: 'dl-action-button',
					itemid: 'delete',
					theme: 'error primary',					
					permissions: ['ADMIN_ALERTS_MANAGEMENT:DELETE', 'ALERT_MANAGEMENT:DELETE'],
					'class': 'spacer-toolbar-item',
					style: 'float: right;',					
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')
					],
					listeners: {
						click: function() {
							actionDelete(grid.selectedItems[0]);
						}
					}
				}			
			]
		});
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			'page-size': 100,
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [
				{						
					path: 'name',
					header: 'Name',					
					width: '7em'
				},				
				{						
					path: 'alertTypeDescription',
					header: 'Type',					
					width: '9em'
				},
				{						
					path: 'urgencyLevel',
					header: 'Urgency',					
					width: '9em'
				},
				{						
					path: 'messageSendMethod',
					header: 'Send Method',					
					width: '9em'
				},
				{						
					path: 'deliveryOption',
					header: 'Delivery Address(es)',						
					'flex-grow': '1',
					renderer: function(root, column, rowData) {
						root.innerHTML = rowData.item.deliveryOption.addresses.join(', ');
					}
				},
				{						
					path: 'alertOptions',
					header: 'Options',					
					width: '7em',
					renderer: function(root, column, rowData) {
						var options = [];
						for (var key in rowData.item.alertOptions) {
							var label = key.replace(/_/g, ' ').toLowerCase();
							label = StringUtil.capitalizeFirstLetter(label);
							
							options.push('<b>' + label + ': </b> ' + rowData.item.alertOptions[key]);
						}						
						root.innerHTML = options.join('<br>');
					}
				},	
				{						
					path: 'adminEvent',
					header: 'Admin Alert',					
					width: '7em'
				},
				{						
					path: 'createUser',
					header: 'Create User',					
					width: '7em'
				},				
				{						
					path: 'updateDts',
					header: 'Update Date',					
					width: '7em',
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0 && !grid.selectedItems[0].coreModule) {												
						ElementUtil.query(toolbar, 'updateStatus').disabled = false;
						if (alertGrid.user && grid.selectedItems[0].adminEvent) {
							ElementUtil.query(toolbar, 'edit').disabled = true;
						} else {
							ElementUtil.query(toolbar, 'edit').disabled = false;
						}
						ElementUtil.query(toolbar, 'delete').disabled = false;
					} else {												
						ElementUtil.query(toolbar, 'updateStatus').disabled = true;
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}	
				}
			}
		});		
		
		grid.dataProvider = function(params, callback) {
		
			var loadMask = grid.showLoading();
			alertGrid.currentFilter = {
				offset: params.page * params.pageSize,
				max: params.pageSize,
				sortField: params.sortOrders && params.sortOrders.length > 0 ? params.sortOrders[0].path : null,
				sortOrder: params.sortOrders && params.sortOrders.length > 0 ? params.sortOrders[0].direction.toUpperCase() : null,
				status: ElementUtil.query(toolbar, 'status').value						
			};

			var successHandler = function(records) {
				loadMask.remove();
				grid.activeItem = null;						
				callback(records.data, records.totalNumber);				
			};

			Service.getAlertService().getAlerts(alertGrid.currentFilter)
			.then(function(records){							
				successHandler(records);
			});
			
		};
		
		var footer = ExportUtil.createExportFooter({
			grid: grid,
			itemid: 'alerts',
			showDetail: false
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});
		alertGrid.append(flexLayout);
				
		var actionRefresh = function() {
			grid.clearCache();			
		};		
		
		var actionAddEdit = function(record) {
			
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Add/Edit Alert',
				icon: 'vaadin:edit',
				listeners: {
					ready: function() {
						
						addEditWin.show();
						
						var allAlertTypes = [];
						var loadFormAction = function() {
							if (record) {

								//adjust addresses 
								var copy = Object.assign({}, record);
								copy.address = record.deliveryOption.addresses.join(', ');
										
								formPanel.load(copy, {
									refreshComponents: true
								});
								
								//adjust options
								copy = ElementUtil.objToDotNotation(copy);
								
								//find alert type
								if (copy.alertType) {									
									var selectedAlertType;
									allAlertTypes.forEach(function(type){
										if (copy.alertType === type.code) {
											selectedAlertType = type;
										}
									});
									
									if (selectedAlertType) {
										handleOptionChange(selectedAlertType);
										
										formPanel.load(copy, {
										refreshComponents: true
										});
									}									
								}																
							}
						};
						
						var handleOptionChange = function(alertType) {
							
							var optionPanel = ElementUtil.query(formPanel, 'options');													
							ElementUtil.removeAllChildren(optionPanel);
							
							var allOptions = [];
							for (var optionKey in alertType.options) {
								var optionDetails = alertType.options[optionKey];

								if (optionDetails.dataType === 'Boolean') {	
									allOptions.push(ElementUtil.create({
										tag: 'vaadin-checkbox',
										name: 'alertOptions.' + optionKey,
										label: optionDetails.description
									}));
								} else if (optionDetails.dataType === 'List') {	
									allOptions.push(ElementUtil.create({
										tag: 'vaadin-combo-box',																
										name: 'alertOptions.' + optionKey,
										label: optionDetails.description,
										'item-value-path': 'code',
										'item-label-path': 'description',
										postinit: function (combo) {
											optionDetails.lookups.sort(function(a, b){
												return a.description.localeCompare(b.description);
											});
											combo.items = optionDetails.lookups;																	
										}
									}));
								} else if (optionDetails.dataType === 'String') {	
									allOptions.push(ElementUtil.create({
										tag: 'vaadin-text-field',
										name: 'alertOptions.' + optionKey,
										label: optionDetails.description
									}));
								} else if (optionDetails.dataType === 'UserCompanies') {	
									allOptions.push(ElementUtil.create({
										tag: 'vaadin-combo-box',																
										name: 'alertOptions.' + optionKey,
										label: optionDetails.description,
										'item-value-path': 'code',
										'item-label-path': 'description',
										postinit: function (combo) {																	
											Service.getUserService().getCurrentUser().then(function (user) {

												var companyLookups = [];
												user.companies.forEach(function(company){
													var primary = false;
													if (company.companyId === user.primaryCompany.companyId) {
														primary = true;
													}

													companyLookups.push({
														code: company.companyId,
														description: company.companyName + (primary ? ' (primary)' : '')
													});
												});

												combo.items = companyLookups;
											});																
										}
									}));
								}
							}
							if (allOptions.length > 0) {
								allOptions.forEach(function(element){
									optionPanel.append(element);
								});	
								
								setTimeout(function(){
									ElementUtil.query(formPanel, 'options-fs').style.width = 'calc(98% + 0rem)';													
								}, 100);						
							}							
							
						};
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-text-field',
											label: 'Name',
											name: 'name',
											required: true,
											maxlength: 255
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'alertType',
											label: 'Alert Type', 
											name: 'alertType',
											'item-value-path': 'code',
											'item-label-path': 'description',											
											postinit: function(combo) {
												Service.getLookupService().getLookupValues('AlertType').then(function(data){																										
													if (alertGrid.user) {
														var filtered = data.filter(function(type) {
															return !type.adminEvent;
														}); 	
														
														allAlertTypes = filtered.slice();
														combo.items = filtered;																	
													} else {													
														allAlertTypes = data.slice();
														combo.items = data;														
													}													
													loadFormAction();
													combo.required = true;
												});
											}, 
											listeners: {
												change: function(event) {
																										
													if (event.target.selectedItem) {
														handleOptionChange(event.target.selectedItem);
													}
													
												}
											}
										},
										{
											tag: 'vaadin-combo-box',
											label: 'Delivery Method', 
											name: 'messageSendMethod',
											'item-value-path': 'code',
											'item-label-path': 'description',										
											postinit: function(combo) {
												Service.getLookupService().getLookupValues('MessageSendMethod').then(function(data){
													combo.items = data;
													combo.required = true;
												});
											},
											value: 'EMAIL'
										},
										{
											tag: 'vaadin-combo-box',
											label: 'Urgency Level',
											name: 'urgencyLevel',
											'item-value-path': 'code',
											'item-label-path': 'description',											
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('UrgencyLevel').then(function (data) {
													combo.items = data;
													combo.value = 'NORMAL';
													combo.required = true;
												});
											}
										},										
										{
											tag: 'vaadin-text-field',
											label: 'Address(es) (comma-separated)',
											name: 'address',
											required: true,
											maxlength: 1024
										},
										{
											tag: 'fieldset',
											itemId: 'options-fs',
											colspan: 2,
											children: [
												{
													tag: 'legend',													
													innerHTML: 'Options'
												},
												{
													tag: 'vaadin-form-layout',
													itemid: 'options'
												}
											],
											postinit: function(element) {
												setTimeout(function(){
													element.style.width = 'calc(98% + 0rem)';													
												}, 100);												
											}
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																														
															if (formPanel.isValid()) {
																
																var data = formPanel.getData();																																
																
																//options
																data = ElementUtil.dotNotationToObj(data);
																
																//unpack addresses
																data.deliveryOption = {
																	addresses: []
																};																
																var addresses = data.address.split(',');
																addresses.forEach(function(address){
																	data.deliveryOption.addresses.push(address.trim());
																});
																delete data.address;
																
																if (record) {
																	data.alertId = record.alertId;
																}
																
																var loadMask = formPanel.showLoading('Saving...');
																Service.getAlertService().saveAlert(data, record ? true : false).then(function(result){
																	loadMask.remove();
																	actionRefresh();
																	addEditWin.close();
																});																
																
															}	
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]

						});
						addEditWin.addToContentElement(formPanel);	
												
					}
				}
			});
			
		};
		
		var actionUpdateStatus = function(record) {
			var loadMask = grid.showLoading('Updating...');	
			if (record.activeStatus === 'A') {
				Service.getAlertService().inactivateAlert(record.alertId).then(function(){
					loadMask.remove();				
					actionRefresh();
				});	
			} else {
				Service.getAlertService().activateAlert(record.alertId).then(function(){
					loadMask.remove();				
					actionRefresh();
				});
			}			
		};
		
		var actionDelete = function(record) {
			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete ' + record.name + ' alert?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Deleting alert...');													
							
							Service.getAlertService().deleteAlert(record.alertId).then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Deleted alert: ' + record.name, {									
									theme: 'success'
								});
								actionRefresh();
							});															
							
						}	
					},
					{
						text: 'No'
					}
				]
			});
		};
		
	}
	
}
customElements.define('dl-alert-grid', AlertGrid);

